/**
 * 협력사 정보변경 모달 ($j.F.Partner.InfoModal) — /p/ 상단바의 '정보변경'.
 *
 * 폼 마크업은 레이아웃의 <template id="p-info-tpl"> 에 있다 ($user 값을 블레이드가
 * 채운다).
 * <template> 을 쓰는 이유: 안에 든 input 의 id 가 문서 id 공간에 노출되지 않아, 모달로 복제해도
 * 중복 id 가 생기지 않는다.
 *
 * 레거시 public/js/scs.js 의 changeInfoco() 를 대체한다. 그쪽은 저장 성공 후 레거시 화면의
 * id(#infoChangediv)를 숨기는데 /p/ 에는 그 엘리먼트가 없어 모달이 닫히지 않았다.
 * (scs.js 는 오더 확인체크/메모 전역 때문에 계속 로드된다 — 정보변경만 여기로 가져온 것)
 */
export default class InfoModal {
    static ID = 'p-info-modal';

    /** 상단바 '정보변경' → 모달 열기 */
    static open() {
        const tpl = document.getElementById('p-info-tpl');
        if (!tpl) return;
        $j.Ui.JBModal.html(this.ID, tpl.innerHTML, '정보변경', { width: '440px' });
    }

    static close() {
        $j.Ui.JBModal.close(this.ID);
    }

    static _val(id) {
        return ($('#' + id).val() || '').trim();
    }

    /**
     * 저장. 비밀번호는 현재 비밀번호를 함께 넣어야 바뀌고, 연락처만 바꾸는 것도 된다.
     * 서버(Partner\PartnerController@changeInfo)는 대상 소속코드를 세션에서 가져오므로
     * 여기서 보내는 login_num 은 서버가 쓰지 않는다.
     */
    static save() {
        const pwNow = this._val('changepwdnow');
        const pw1   = this._val('changepwd1');
        const pw2   = this._val('changepwd2');
        const tel   = this._val('co_tel');
        const type  = this._val('login_type');

        if (!['scsbonsa', 'scsgisa', 'scscenter'].includes(type)) {
            alert('지사 또는 센터 구분이 없습니다.');
            return;
        }
        if (pwNow.length > 0) {
            if (pw1.length < 4 || pw2.length < 4) { alert('변경할 비밀번호를 4자 이상 입력해 주세요.'); return; }
            if (pw1 !== pw2) { alert('변경할 비밀번호와 비밀번호 확인이 일치하지 않습니다.'); return; }
        }
        // 원본 연락처는 data_cd 에 있다 — 바뀐 게 없고 비밀번호도 안 건드렸으면 보낼 이유가 없다
        if ($('#co_tel').attr('data_cd') === tel && pwNow.length < 1) {
            alert('변경사항이 없습니다.');
            return;
        }

        $.ajax({
            type: 'POST',
            url: '/p/ajax/member/info/change',
            data: {
                changepwdnow: pwNow,
                changepwd1: pw1,
                changepwd2: pw2,
                co_tel: tel,
                login_type: type,
                login_num: this._val('login_num'),
            },
            success: (data) => {
                const rt = parseInt(data.error, 10) || 0;
                if (rt === -9) { alert('회원 번호가 없거나 올바르지 않아 변경하지 못했습니다.'); return; }
                if (rt === -1) { alert('현재 비밀번호가 올바르지 않아 변경하지 못했습니다.'); return; }
                if (rt !== 1)  { alert('정보를 변경하지 못했습니다.'); return; }

                alert('정보가 변경되었습니다.');
                this.close();
            },
            error: () => alert('정보를 변경하지 못했습니다.'),
        });
    }
}
